import { type MouseEvent, type PointerEvent, type ReactNode, useRef } from "react";

/** A drag past this is a scrub, not a tap on the card around the chart. */
const DRAG_SLOP = 6;
export type ScrubAreaProps = {
  /** x within the chart while pressed or hovered; null once let go. */
  onScrub: (x: number | null) => void;
  children: ReactNode;
};
export function ScrubArea({
  onScrub,
  children
}: ScrubAreaProps) {
  const downX = useRef<number | null>(null);
  const at = (e: PointerEvent<HTMLDivElement>) => onScrub(e.clientX - e.currentTarget.getBoundingClientRect().left);
  // A scrub ends in a click; keep it from opening a pressable parent.
  const swallowDrag = (e: MouseEvent<HTMLDivElement>) => {
    if (downX.current !== null && Math.abs(e.clientX - downX.current) > DRAG_SLOP) {
      e.stopPropagation();
      e.preventDefault();
    }
  };
  return (
    // Raw div: Tamagui's stacks don't take onClickCapture.
    <div data-testid="coverage.chart-scrub" style={{
      position: "relative",
      height: "100%",
      touchAction: "none"
    }} onPointerDown={e => {
      downX.current = e.clientX;
      e.currentTarget.setPointerCapture?.(e.pointerId);
      at(e);
    }} onClickCapture={swallowDrag} onPointerMove={at} onPointerLeave={() => onScrub(null)} onPointerCancel={() => onScrub(null)} onPointerUp={e => e.pointerType === "touch" ? onScrub(null) : undefined} data-sentry-component="ScrubArea" data-sentry-source-file="ScrubArea.tsx">
      {children}
    </div>
  );
}